import { useCurrentWorkspace, useQueryWorkspaces } from '@heidi/workspace/data';

/** Active workspace role for who can self-serve a pricing-plan upgrade. */
export function usePricingPlansUpgradeRole() {
  const workspace = useCurrentWorkspace();
  const workspacesQuery = useQueryWorkspaces();

  const hasNoWorkspace =
    workspacesQuery.isSuccess && (workspacesQuery.data?.workspaces.length ?? 0) === 0;
  // Stay closed on null workspace until the list proves empty (incl. errors).
  const isWorkspaceRoleUnresolved = workspace == null && !hasNoWorkspace;

  const isWorkspaceAdmin =
    workspace != null ? workspace.user_role === 'ADMIN' : undefined;
  const isNonAdminWorkspaceMember = workspace != null && workspace.user_role !== 'ADMIN';

  return {
    isWorkspaceAdmin,
    isNonAdminWorkspaceMember,
    isWorkspaceRoleUnresolved,
  };
}
